/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { EnginesCatalog } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { useLogger } from '@hooks';
import { useFetchRetrieveContext } from '@services';
import { integratedSolutionFlowPath, ROUTES, useNavigation } from '@navigation';
import { ErrorCaeOrAml } from './modals/errorCaeOrAml';
import { ShowHideHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { GLOBAL_LOADER } from './components/globalLoader';
import { useDisableIntegratedSolutionFlow, useIsOperator } from '@store';

export const App: React.FC = (): JSX.Element => {
	const logger = useLogger();
	const { success } = useFetchRetrieveContext();
	const isOperator = useIsOperator();
	const { navigate, exit } = useNavigation();
	const history = useHistory();
	const isDisable = useDisableIntegratedSolutionFlow();

	useEffect(() => {
		if ((success || isOperator) && window.location.pathname === '/') {
			navigate('intro');
		}
	}, [isOperator, navigate, success]);

	useEffect(() => {
		if (integratedSolutionFlowPath.includes(window.location.pathname) && isDisable) {
			navigate('intro');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [window.location.pathname, isDisable]);

	logger('App');

	useEffect(() => {
		return history.listen(() => {
			if (history.action === 'POP') {
				ShowHideHelper.show(GLOBAL_LOADER);
				exit();
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [history.action]);

	return (
		<>
			{(success !== undefined || isOperator) && (
				<Switch>
					<Route exact path={ROUTES.requestContact}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('requestContact', {})}
					</Route>
					<Route exact path={ROUTES.serviceError}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('serviceError', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionSelectPlan}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionSelectPlan', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionSelectAccount}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionSelectAccount', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionTermsAndConditionsSoftware}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionTermsAndConditionsSoftware', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionTermsAndConditionsBank}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionTermsAndConditionsBank', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionResumeAndAuthorization}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionResumeAndAuthorization', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionConclusion}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionConclusion', {})}
					</Route>

					<Route exact path={ROUTES.integratedSolutionSelectSolution}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('integratedSolutionSelectSolution', {})}
					</Route>
					<Route exact path={ROUTES.integratedSolutionSelectAccount}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('integratedSolutionSelectAccount', {})}
					</Route>
					<Route exact path={ROUTES.integratedSolutionTermsAndConditionsBank}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('integratedSolutionTermsAndConditionsBank', {})}
					</Route>
					<Route exact path={ROUTES.integratedSolutionResumeAndAuthorization}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('integratedSolutionResumeAndAuthorization', {})}
					</Route>
					<Route exact path={ROUTES.integratedSolutionConclusion}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('integratedSolutionConclusion', {})}
					</Route>

					<Route exact path={ROUTES.intro}>
						{EnginesCatalog.getInstance(EnginesCatalog).getPrismEngine().instantiatePrism('intro', {})}
					</Route>
					<Route exact path={ROUTES.root}>
						{EnginesCatalog.getInstance(EnginesCatalog).getPrismEngine().instantiatePrism('_root', {})}
					</Route>
				</Switch>
			)}
			<ErrorCaeOrAml />
		</>
	);
};
